import React from 'react';

interface AccessibleButtonProps extends React.HTMLAttributes<HTMLDivElement> {
  onClick: (e: React.MouseEvent<HTMLDivElement> | React.KeyboardEvent<HTMLDivElement>) => void;
  disabled?: boolean;
  children: React.ReactNode;
  className?: string;
  tabIndex?: number;
  role?: string;
  ariaLabel?: string;
}

const AccessibleButton = React.forwardRef<HTMLDivElement, AccessibleButtonProps>(
  (
    {
      onClick,
      disabled = false,
      children,
      className,
      tabIndex = 0,
      role = 'button',
      ariaLabel,
      ...rest
    },
    ref
  ) => {
    return (
      <div
        ref={ref}
        className={className}
        tabIndex={disabled ? -1 : tabIndex}
        role={role}
        aria-disabled={disabled}
        aria-label={ariaLabel}
        onClick={e => {
          if (!disabled) {
            onClick(e);
          }
        }}
        onKeyDown={e => {
          if (!disabled && (e.key === 'Enter' || e.key === ' ')) {
            e.preventDefault();
            e.currentTarget.click();
          }
        }}
        {...rest}
      >
        {children}
      </div>
    );
  }
);

export default AccessibleButton;
